export class QpMessageFadeindownProvider {

    private FADE_DOWN_DURATION_TIME: number = 2000;

    public setDurationTime(fadeDownDurationTime: number) {
        if (typeof fadeDownDurationTime == "number") {
            this.FADE_DOWN_DURATION_TIME = fadeDownDurationTime;
        }
    }

    public $get = ["$rootScope", "$templateCache", "$timeout", "$compile",
        function (
            $scope: qpui.bootstrap.IQpMessageFadeindownScope,
            $templateCache: angular.ITemplateCacheService,
            $timeout: angular.ITimeoutService,
            $compile: angular.ICompileService
        ) {

        $scope.fadeInDown_isOpen = false;
        
        let FADE_DOWN_DURATION_TIME = this.FADE_DOWN_DURATION_TIME;

        let rootBody = $("body")[0];

        let fadeInDownInstance = {
            show: function (message: string, customDurationTime?: number) {
                if ($scope.fadeInDown_isOpen) {
                    return;
                }
                // 传入的提示文本信息不能为空
                if (angular.isUndefined(message)) {
                    throw new Error("message is missing");
                }

                $timeout(() => {
                    $scope.fadeInDown_isOpen = true;
                    // 设置提示文本
                    $scope.fadeInDown_message = message;
                    let content = $($templateCache.get("qp-message-fadeindown-template.html") as string)[0];

                    rootBody.appendChild(content);
                    $compile(content)($scope);

                    $timeout(() => {
                        // 隐藏元素
                        $scope.fadeInDown_isOpen = false;
                        let child = $(rootBody).children(".fadeindowm-container")[0];
                        if (child) {
                            rootBody.removeChild(child);
                        }
                    }, customDurationTime || FADE_DOWN_DURATION_TIME)
                })
            }
        }

        return fadeInDownInstance;
    }]

}